export default {"src":"/pro/_next/static/media/gbpusd.3de07235.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};